













import { Component, Prop, Provide, Vue } from "vue-property-decorator";
import BaseTable from "@/components/BaseTable.vue";

@Component({
  components: { BaseTable }
})
export default class LoadingTable extends Vue {
  @Prop({ default: 7 }) private rows!: number;
  @Prop({ default: 2 }) private columns!: number;
  @Prop({ default: "52px" }) private rowHeight!: string;
  @Prop({ default: "56px" }) private headerHeight!: string;
  @Provide() private tableData: any[] = [];
  @Provide() private loadingColumnArray: any[] = [];

  mounted() {
    this.tableData = Array.from({ length: this.rows - 1 }).map(item => {
      return { item: item };
    });

    this.loadingColumnArray = Array.from({ length: this.columns }).map(item => {
      return { item: item };
    });
  }
}
